(() => {
    const $blocks = document.querySelectorAll('.block');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const minMaxWidth = () => {
            const minWidth = $block.dataset.minWidth;
            const maxWidth = $block.dataset.maxWidth;

            if (!minWidth && !maxWidth) return;

            if (minWidth && window.innerWidth < minWidth) {
                $block.classList.add('block--hidden');
                $block.classList.add('block--skip');
            } else if (maxWidth && window.innerWidth > maxWidth) {
                $block.classList.add('block--hidden');
                $block.classList.add('block--skip');
            } else {
                $block.classList.remove('block--hidden');
                $block.classList.remove('block--skip');
            }
        };

        window.addEventListener('resize', () => {
            minMaxWidth();
        });

        minMaxWidth();
    });
})();
